'use client';

import { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { refreshSession } from '@/src/shared/api/axios';
import { ToastProvider } from '@/src/shared/ui/toast/ToastProvider';

function RestoreSession() {
  useEffect(() => {
    refreshSession().catch(() => undefined);
  }, []);

  return null;
}

export function QueryProvider({ children }: { children: React.ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: false,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={client}>
      <ToastProvider>
        <RestoreSession />
        {children}
      </ToastProvider>
    </QueryClientProvider>
  );
}
